import React from "react";
import { Grid, InputAdornment, TextField } from "@mui/material";

/**
 * Campo de solo lectura usado en los modales de equivalencias ERP.
 * Centraliza los props compartidos del TextField (outlined, small, fullWidth, disabled)
 * y el contenedor Grid. El `value` debe pasarse ya formateado.
 */
export const ReadOnlyField = ({
  label,
  value,
  xs = 12,
  sm = 12,
  type = "text",
  multiline = false,
  rows,
  adornment,
}) => (
  <Grid item xs={xs} sm={sm}>
    <TextField
      label={label}
      type={type}
      value={value}
      variant="outlined"
      size="small"
      fullWidth
      disabled
      multiline={multiline}
      rows={rows}
      InputProps={adornment ? {
        startAdornment: <InputAdornment position="start">{adornment}</InputAdornment>,
      } : undefined}
    />
  </Grid>
);
